import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import CreateButton from 'components/button/CreateButton';
import Header from 'components/ui/general/Header';
import Title from 'components/ui/general/Title';
import AccountsList from './AccountsList';
import filterMatchTypes from 'components/list/Filters/filterMatchTypes';
import translate from 'components/hoc/translate';

const AccountsListContainer = (props) => {
    const {
        resource,
        translate,
    } = props;

    const initialFilters = {
        is_enabled: {
            matchType: filterMatchTypes.equals,
            value: '1',
        },
    };

    return (
        <div>
            <Header>
                <Title title={ translate('resources.accounts.title') } />

                <Actions>
                    <CreateButton basePath={ resource } />
                </Actions>
            </Header>

            <AccountsList
                { ...props }
                initialFilters={ initialFilters }
            />
        </div>
    );
};

AccountsListContainer.propTypes = {
    resource: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(AccountsListContainer);



// WEBPACK FOOTER //
// ./src/pages/accounts/list/AccountsListContainer.js